import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PremyopiaRiskScoreComponent } from './premyopia-risk-score/premyopia-risk-score.component';
import { COMMON_IMPORTS } from '../common-imports';
import {
  AxialLengthType,
  EyeSideValues,
  GraphDataEthnicity,
  MyopeProgressionType,
  PercentileQualifier,
  PredictedAt18Qualifier,
  PremyopeRiskScoreCategory,
  SERValueType,
  SingleMyopRiskAt18Result,
  SingleVisitAnnualSERCategory,
  SingleVisitMyopeAgeCategory,
} from '../backend-response-models/calc-enums.helper';
import { PremyopiaScoreBreakdownComponent } from './premyopia-score-breakdown/premyopia-score-breakdown.component';
import { PremyopiaEimRetestComponent } from './premyopia-eim-retest/premyopia-eim-retest.component';
import { SerPercentileComponent } from '../ser-stats/ser-percentile/ser-percentile.component';
import {
  AxialCalcResponse,
  CalcTreatmentResponse,
  CalculationResults,
  MyopeProgressionResults,
  SerCalcResponse,
  SingleMyopeResults,
} from '../backend-response-models/calc-interfaces.helper';
import { AxialPercentileComponent } from '../axial-stats/axial-percentile/axial-percentile.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CalculationService } from '../shared/shared-services/calcuation.service';
import { FutureMyopiaComponent } from '../myopia-single-dashboard/future-myopia/future-myopia.component';
import { MyopiaProgressionComponent } from '../myopia-progression-dashboard/myopia-progression/myopia-progression.component';
import { ParentParagraphComponent, ParentParagraphType } from '../parent-paragraph/parent-paragraph.component';
import { PopulationComparisonComponent } from '../population-comparison/population-comparison.component';
import { CreditsComponent } from '../credits/credits.component';
import { ReportType } from '../shared/shared-enums/shared.enums';
import { StandardProgressionComponent } from '../standard-progression/standard-progression.component';
import { PatientInfoInputComponent } from '../patient-info-input/patient-info-input.component';

@Component({
  selector: 'app-premyopia-dashboard',
  standalone: true,
  imports: [
    ProgressSpinnerModule,
    PremyopiaRiskScoreComponent,
    PremyopiaEimRetestComponent,
    PopulationComparisonComponent,
    ParentParagraphComponent,
    CreditsComponent,
    ...COMMON_IMPORTS,
    StandardProgressionComponent,
    PatientInfoInputComponent,
  ],
  templateUrl: './premyopia-dashboard.component.html',
  styleUrl: './premyopia-dashboard.component.css',
})
export class PremyopiaDashboardComponent implements OnInit {
  PremyopeRiskScoreCategory = PremyopeRiskScoreCategory;
  GraphDataEthnicity = GraphDataEthnicity;
  ParentParagraphType = ParentParagraphType;
  ReportType = ReportType;

  @Input({ required: true })
  calculationResults!: CalculationResults;

  @Input({ required: true })
  reportType!: ReportType;

  @Input()
  patientName: string = 'Anonymous';

  currentEthnicity: GraphDataEthnicity = GraphDataEthnicity.WESTERN;
  retestPeriodsMonths: number = 18;

  ngOnInit(): void {
    this.retestPeriodsMonths = this.calculationResults.premyopeRiskResults?.retestPeriodMonths ?? 18;
  }

  onEthnicityChange(newEthnicity: GraphDataEthnicity): void {
    this.currentEthnicity = newEthnicity;
  }
}
